const FUNDAMENTO_LEGAL_REGIME_TRB_II_UNIAO_ESTADOS_CODE = '03';
const FUNDAMENTO_LEGAL_REGIME_TRB_II_DRAWBACK_CODE = '16';

export {
  FUNDAMENTO_LEGAL_REGIME_TRB_II_DRAWBACK_CODE,
  FUNDAMENTO_LEGAL_REGIME_TRB_II_UNIAO_ESTADOS_CODE,
};
